<template>
<div class="workpage-right-column">

    <v-container v-if="loading">
        <div v-for="index in 10" :key="'skeleton-prod' + index">
            <v-divider class="my-6"></v-divider>
        <v-row>
            <v-col cols="12" sm="6" v-for="i in 2" :key="i">
                <v-row no-gutters>
                    <v-col cols="12" sm="4">
                        <v-skeleton-loader
                            type="image"
                        ></v-skeleton-loader>  
                    </v-col>
                    <v-col cols="12" sm="8">
                        <v-skeleton-loader
                            type="article"
                        ></v-skeleton-loader> 
                        <v-skeleton-loader
                        class="ml-4"
                            type="heading"
                        ></v-skeleton-loader>  
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        </div>

        <v-row v-for="i in 7" :key="'skeleton-desc' + i">
            <v-col cols="12">
                <v-skeleton-loader
                    min-width="1000"
                    type="heading"
                ></v-skeleton-loader>  
            </v-col>
            <v-col cols="12">
                <v-skeleton-loader
                    type="paragraph"
                ></v-skeleton-loader>  
            </v-col>
        </v-row>
    </v-container>


    <v-fade-transition>

            <div v-if="!loading">
                <div>
                    <h1>{{category.name}}</h1>

                    <div class="catitems-wrapper">
                    <div v-for="(product, i) in curProducts" :key="i" class="catitem" id="bx_3966226736_1393">
                        <router-link class="catitem-image" :to="{name: 'product', params: {groupId: groupId, id: product.id}}">
                            <da-img :src="product.fileCovers && product.fileCovers[0] && product.fileCovers[0].urlMin" :aspect-ratio="0.74" />  
                        </router-link>

                        <div class="catitem-specs">
                            <router-link :to="{name: 'product', params: {groupId: groupId, id: product.id}}" class="catitem-title">{{product.name}}</router-link>

                            <p class="catitem-description">{{product.description}}</p>

                            <router-link class="catitem-more" :to="{name: 'product', params: {groupId: groupId, id: product.id}}">Узнать&nbspбольше</router-link>
                        </div>
                        </div>  
                    </div>


			        <div class="showed-items pb-4">
                        <div class="float-right">Показано {{curProducts.length}} из {{total}}</div>
                        </div>
                </div>

                <div class="clear-both mt-12" v-html="catDescription.text"></div>
            </div>
    </v-fade-transition>
	</div>		
</div>
</template>

<script>
import ProdMixin from '@/mixins/ProdMixin.vue';
    export default {
        mixins: [ProdMixin],
        created () {
            this.prodMixinInit();
            this.fetchProducts();
            this.$store.dispatch('fetchCatDesc', {groupId: this.groupId});
        },
        data() {
            return {
                page: 1
            }
        },
    }
</script>

<style lang="scss" scoped>
.catitems-wrapper{
    .img-wrap{
        position: relative;
        height: 181px;
        width: 133px;
        // padding-bottom: 136.1%;
        img{
            position: absolute;
            width: 100%;
        }
    }
}
</style>